export class EmailTemplateCodes {

    public static ACCOUNT_ACTIVATED: number = 1;    
    public static USER_PASSWORD_CHANGED: number = 2;
    public static USER_ID_EMAIL: number = 3;
    public static USER_ID_CHANGED: number = 4;
    public static FORGOT_PASSWORD: number = 5;   
    public static ACCOUNT_DISABLED: number = 6;       
}
